import React, { memo } from "react";
import CreatableSelect from "react-select/creatable";
import { components } from "react-select";
import { Tooltip } from "antd";

// const CustomMultiValue = (maxTagCount) => {
//   return memo((props) => {
//     const { data, selectProps } = props;

//     const selectedValues = Array.isArray(selectProps.value)
//       ? selectProps.value
//       : [selectProps.value].filter(Boolean);

//     // const selectedValues = props.selectProps?.value || [];

//     // const index = selectedValues.findIndex(
//     //   (val) => val.value === props.data.value
//     // );

//     const index = selectedValues.findIndex((v) => v.value === data.value);

//     if (index < maxTagCount) {
//       return <components.MultiValue {...props} />;
//     }

//     if (index === maxTagCount) {
//       const hiddenValues = selectedValues.slice(maxTagCount);
//       const tooltipTitle = hiddenValues.map((opt) => opt.label).join(", ");

//       return (
//         <div>
//           <Tooltip title={tooltipTitle}>
//             {/* <components.MultiValueContainer {...props}> */}
//             <div
//               style={{
//                 padding: "3px 6px",
//                 background: "#fbf8f3",
//                 borderRadius: "2px",
//                 display: "inline-flex",
//                 alignItems: "center",
//                 fontSize: "0.85rem",
//                 color: "#d3b474",
//                 marginRight: "4px",
//                 maxWidth: "100%"
//               }}
//             >
//               +{hiddenValues.length} more
//             </div>
//             {/* </components.MultiValueContainer> */}
//           </Tooltip>
//         </div>
//       );
//     }

//     return null;
//   });
// };

const CustomMultiValue = (maxTagCount) => {
  return memo((props) => {
    const { data, selectProps } = props;
    const selectedValues = Array.isArray(selectProps.value)
      ? selectProps.value
      : [selectProps.value].filter(Boolean);

    const index = selectedValues.findIndex((v) => v.value === data.value);

    // If only one item selected, render normally
    if (selectedValues.length === 1) {
      return <components.MultiValue {...props} />;
    }

    // Only render once (at index 0) the +N more tag
    if (index === 0) {
      const tooltipTitle = selectedValues.map((opt) => opt.label).join(", ");
      return (
        <Tooltip title={tooltipTitle}>
          <div className="selected-view">+{selectedValues.length} selected</div>
        </Tooltip>
      );
    }

    // Don't render anything for other items
    return null;
  });
};

const CustomCreatableSelect = ({
  name,
  value,
  options,
  onChange,
  onCreate,
  disabled,
  isMulti = false,
  maxTagCount = 2,
  className
}) => {
  const handleChange = (newValue) => {
    onChange(newValue, name);
  };

  const handleCreate = (inputValue) => {
    if (onCreate) {
      const newOption = {
        label: inputValue,
        value: inputValue.toLowerCase().replace(/\W/g, "")
      };

      if (isMulti || onCreate) {
        const current = value || [];
        const optionValue =
          !current && !current?.length ? [newOption] : [...current, newOption];

        onChange(optionValue, name);
      } else {
        onChange(newOption, name);
      }
    }
  };

  return (
    <CreatableSelect
      isClearable
      isMulti={isMulti}
      value={value}
      options={options}
      onChange={handleChange}
      onCreateOption={handleCreate}
      components={{
        MultiValue: CustomMultiValue(maxTagCount)
      }}
      hideSelectedOptions={false}
      isDisabled={disabled}
      maxMenuHeight={250}
      className={className}
      classNamePrefix="filter"
      menuPlacement="auto"
      menuPosition="absolute"
      closeMenuOnSelect={!isMulti}
    />
  );
};

export default memo(CustomCreatableSelect);
